// Globals
import { FC } from 'react';

// Components
import { TrashIcon } from '@/icons';
import { Button } from '@/ui';
import { StyledButtons } from './RedirectDeleteModalContentStyles';

type TRedirectDeleteModalContentProps = {
  isLoading: boolean;
  onDelete: () => void;
  description: string;
  btnTitle: string;
};

const RedirectDeleteModalContent: FC<TRedirectDeleteModalContentProps> = ({
  isLoading,
  description,
  onDelete,
  btnTitle,
}) => {
  return (
    <div>
      <p>{description}</p>
      <StyledButtons>
        <Button type="primary" danger size="small" onClick={onDelete} icon={<TrashIcon />} loading={isLoading}>
          {btnTitle}
        </Button>
      </StyledButtons>
    </div>
  );
};

export default RedirectDeleteModalContent;
